import React from 'react';
import ProfessionalHistory from '../components/ProfessionalHistory';
import BookPage from '../components/common/BookPage';

const ProfessionalPage = () => {
  return (
    <BookPage
      eyebrow="Day Job"
      title="Where I've been."
      intro="Where I'm at."
    >
      <ProfessionalHistory />
    </BookPage>
  );
};

export default ProfessionalPage;
